import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5f2b990"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex pt-[10px]" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["innerHTML"]

import { withDefaults, ref, watch, nextTick, Ref } from 'vue';
import { IItem } from '@/interface/article.d';
interface IProps {
    dataList: Array<Partial<IItem>>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DevelopmentHistory',
  props: {
    dataList: { default: () => [{}] }
  },
  setup(__props: any) {

const leftRef = ref();

const currentId = ref('');

const myRefs = ref([]) as Ref<any[]>;

const refContent = ref<HTMLDivElement | null>(null)
/*锚链接跳转*/
function anchor(anchorName) {
    currentId.value = anchorName
    /*找到锚点*/
    let anchorElement = document.getElementById(anchorName);
    /*如果对应id的锚点存在，就跳转到锚点*/
    if (anchorElement) {

        anchorElement.scrollIntoView();
        nextTick(() => {
            if (anchorElement) {
                document.documentElement.scrollTop -= 90
            }
        })

    }
}
const props = __props;

watch(() => props.dataList, (val) => {
    if (val.length) {
        currentId.value = props.dataList[0].title!;
        nextTick(() => {
            if (refContent.value && leftRef.value) {
                refContent.value.style.height = refContent.value.scrollHeight + 'px';
                leftRef.value.style.height = refContent.value.scrollHeight + 'px';
            }
        })
    }
}, { deep: true })

const handleScroll = (e) => {
    // 滚动后的高度
    const scrollTop = e.target.scrollTop

    // a: 滚动时，获取当前可视区域的元素
    const currentElement = myRefs.value.find((item) => {
        if (item) {
            const offsetTop = item.offsetTop
            const offsetHeight = item.offsetHeight
            return scrollTop >= offsetTop && scrollTop < offsetTop + offsetHeight
            // q: offsetTop是元素相对于父元素的偏移量，offsetHeight是元素的高度，scrollTop是滚动条滚动的距离
        }
    })
    // a: 获取currentElement元素上的title属性
    if (currentElement) {
        currentId.value = currentElement.title
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "left sticky top-[100px] left-0 h-[600px] z-10",
      ref_key: "refContent",
      ref: refContent
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          onClick: ($event: any) => (anchor(item.title)),
          class: _normalizeClass(["text-[26px] font-bold pr-[24px] right-pointer cursor-pointer mt-[-10px]", [currentId.value == item.title ? 'text-[var(--el-color-primary)] active' : 'text-[#333333]']])
        }, _toDisplayString(item.title), 11, _hoisted_2))
      }), 128))
    ], 512),
    _createElementVNode("div", {
      class: "right z-1 relative",
      onScroll: handleScroll,
      ref_key: "leftRef",
      ref: leftRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          title: item.title,
          ref_for: true,
          ref: el => myRefs.value[index] = el,
          key: item.id
        }, [
          _createElementVNode("a", {
            id: item.title,
            class: "block"
          }, null, 8, _hoisted_4),
          _createElementVNode("p", _hoisted_5, _toDisplayString(item.digest), 1),
          _createElementVNode("div", {
            class: "news indent-[2em]",
            innerHTML: item.content
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_3))
      }), 128))
    ], 544)
  ]))
}
}

})